import { Action, State, StateContext, Store } from "@ngxs/store";
import { Manager } from "../models/manager.model";
import { Injectable } from "@angular/core";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { ManagerActions } from "./manager.actions";
import { ManagerService } from "../services/manager.service";

export class ManagerStateModel {
  public managersMap: Manager[];
  public isLoadingManagers: boolean;
}

const defaults = {
  managersMap: [],
  isLoadingManagers: false,
}

@State<ManagerStateModel>({
  name: 'manager',
  defaults,
})
@Injectable()
export class ManagerState {
  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private managerService: ManagerService,
    public store: Store
  ) {}

  @Action(ManagerActions.GetManagersMap)
  getManagersMap (ctx: StateContext<ManagerStateModel>, { }: ManagerActions.GetManagersMap) {
    return this.managerService.getManagersMap()
      .subscribe({
        next: (response) =>
          ctx.dispatch(new ManagerActions.GetManagersMapSuccess(response)),
        error: (error) =>
          ctx.dispatch(new ManagerActions.GetManagersFail(error)),
      });
  }

  @Action(ManagerActions.GetManagersMapSuccess)
  getManagersMapSuccess(ctx: StateContext<ManagerStateModel>, { managers }: ManagerActions.GetManagersMapSuccess) {
    ctx.patchState({
      managersMap: managers.sort((a, b) => a.managerName.localeCompare(b.managerName)),
      isLoadingManagers: false,
    });
  }
}
